import { Box, IconButton, Stack, Typography } from '@mui/material';
import React, { memo } from 'react';
import styles from './styles.module.scss';
import { useTranslation } from 'react-i18next';
import { mergedRemarkItem } from '../../types';
import { CmhcIcon, CmhcIconSize } from '@cmhc-schl/hearth-ui';

const ViewHistoricalRemarksFlyoutHeader = ({
  data,
  toggleFlyout,
  masterPoolNumber
}: {
  data: mergedRemarkItem[];
  toggleFlyout: (event: React.KeyboardEvent | React.MouseEvent) => void;
  masterPoolNumber: number;
}) => {
  const { t } = useTranslation('HbtMasterPool');
  return (
    <Box>
      <Stack
        className={`${styles.headerContainer} ${data.length === 1 ? styles.borderBottom : styles.borderBottom}`}
        direction="row"
        justifyContent="space-between"
      >
        <Box className={styles.headerSubtext}>
          <Typography className={styles.header}>{t('Historical-Remarks')}</Typography>
          {t('Pi-Master-Pool-Inventory-Table-Column-MasterPoolNumber')} {masterPoolNumber}
        </Box>
        <Box>
          <IconButton disableRipple aria-label="close flyout" onClick={toggleFlyout}>
            <CmhcIcon size={CmhcIconSize.LARGE} className={styles.icon} type="icon_close" />
          </IconButton>
        </Box>
      </Stack>
    </Box>
  );
};

export default memo(ViewHistoricalRemarksFlyoutHeader);
